import React, { forwardRef } from "react";

export function getTooltipHTML(fields) {
  return `
    <div class="d-flex flex-column align-items-start text-white" >
      ${Object.entries(fields)
        .map(
          ([label, value]) =>
            value &&
            `
          <div style="white-space: nowrap;">
            <strong>${label}:</strong> ${value?.toLocaleString("en-US")}
          </div>
        `,
        )
        .join("")}
    </div>
  `;
}

const ChartTooltip = forwardRef((_, ref) => {
  return (
    <div
      ref={ref}
      className="chart-tooltip"
      style={{
        position: "absolute",
        opacity: 0,
        background: "#000",
        padding: "6px 10px",
        borderRadius: "4px",
        fontSize: "13px",
        pointerEvents: "none",
        whiteSpace: "nowrap",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        zIndex: 1000,
      }}
    />
  );
});

export default ChartTooltip;
